import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SidebarService {
    public refreshSidebar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}